export { default } from './product-description';
